import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import * as appModalActions from '../../store/appModal/actions'
import AppModalButton from './AppModalButton'
import AppModalLink from './AppModalLink'

const modals = {}

export function registerModal(type, component) {
  modals[type] = component
}

const types = () => Object.keys(modals)
const hasType = type => (type in modals)

function AppModal() {
  const dispatch = useDispatch()
  const props = useSelector(store => store.appModal.props)
  const type = useSelector(store => store.appModal.type)
  const location = useLocation()
  const onClose = useCallback(() => {
    dispatch(appModalActions.closeModal())
  }, [dispatch])

  const Modal = modals[type]
  const isOpen = !!Modal

  useEffect(() => {
    onClose()
  }, [location, onClose])

  if (!isOpen) {
    return null
  }

  return (
    <Modal isOpen onClose={onClose} {...props} />
  )
}

AppModal.Button = AppModalButton
AppModal.Link = AppModalLink
AppModal.types = types
AppModal.hasType = hasType

export default AppModal
